/** The supported full-race field-size bounds from the v1 contract. */
export const MIN_RACE_CAPACITY = 2;
export const MAX_RACE_CAPACITY = 20;
export const DEFAULT_RACE_CAPACITY = 8;

/**
 * Normalize an externally supplied full-race capacity to a safe integer.
 * Non-finite or otherwise non-numeric values use the established eight-kart
 * default; finite values are floored and bounded to the supported range.
 */
export function normalizeRaceCapacity(value: unknown): number {
  if (typeof value !== "number" || !Number.isFinite(value)) return DEFAULT_RACE_CAPACITY;
  return Math.max(MIN_RACE_CAPACITY, Math.min(MAX_RACE_CAPACITY, Math.floor(value)));
}

/** Clamp human ownership to the constructed field without creating a sparse roster. */
export function normalizeRaceHumanSlots(value: unknown, capacity: number): number {
  if (typeof value !== "number" || !Number.isFinite(value)) return 0;
  const max = typeof capacity === "number" && Number.isFinite(capacity)
    ? Math.max(0, Math.floor(capacity))
    : DEFAULT_RACE_CAPACITY;
  return Math.max(0, Math.min(max, Math.floor(value)));
}

/**
 * Return the capacity that a reset should reconstruct from a live state.
 * A one-kart state is reserved for time trials and single-kart challenge
 * modes; normal fields are bounded to the full-race 2..20 contract.
 */
export function getRaceCapacity(race: { readonly karts: readonly unknown[] }): number {
  return race.karts.length === 1 ? 1 : normalizeRaceCapacity(race.karts.length);
}
